"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectResponseModelFiction = void 0;
exports.ProjectResponseModelFiction = {
    Fiction: "fiction",
    NonFiction: "non-fiction",
};
